<template>
	<pop-up-wrapper>
		<div class="pop-up-share-resource">
			<img
				@click="this.$emit('close')"
				class="close"
				src="/img/close.svg"
				alt=""
			/>
			<p class="title">Choisir les élèves à qui vous voulez partager cette ressource</p>
			<div class="students-container">
				<div class="input-container">
					<label for="allClasse">
						<input id="allClasse" v-model="isAllClasseTriggered" type="checkbox" @change="toggleEveryBody">
						Toute la classe
					</label>
				</div>
				<div class="input-container" v-for="student in students" :key="student.id">
					<label><input type="checkbox" v-model="sharedTo" :value="student.id">
					{{ student.name }}</label>
				</div>
				
			</div>
			<button @click="submit" class="submit dark">Valider</button>
		</div>
	</pop-up-wrapper>
</template>

<script>
import { allStudentsInClasseService } from '../../services/studentsService'
import PopUpWrapper from './PopUpWrapper.vue'
import { updateFileService } from '../../services/filesService'
import { updateFolderService } from '../../services/foldersService'
export default {
	components: {
		PopUpWrapper
	},
	props: {
		id: Number,
		type: {
			type: String,
			default: 'file',
			validator: function (value) {
				return ['file', 'folder'].indexOf(value) !== -1
			}
		},
		sharedStudentIds: Array,
	},
	data() {
		return {
			students: [],
			sharedTo: [],
			isAllClasseTriggered: false,
		}
	},
	methods: {
		async submit(){
			const payload = {
				shared_with_students: this.sharedTo
			}
			
			// Utiliser le service approprié selon le type
			if (this.type === 'folder') {
				await updateFolderService(this.id, payload)
			} else {
				await updateFileService(this.id, payload)
			}
			
			this.$store.state.toast = {
				status: 'success',
				text: 'Partage mis à jour',
			}
			this.$emit('update:shared_with_students', this.sharedTo)
			this.$emit('close')
		},
		toggleEveryBody(){
			if(this.sharedTo.length === this.students.length){
				this.sharedTo = []
			}else{
				this.sharedTo = this.students.map(student => student.id)
			}
		},
		async allStudents(){
			this.students = await allStudentsInClasseService(this.$route.params.id)
		},
	},
	created() {
		this.allStudents().then(() => {
			this.sharedTo = [...this.sharedStudentIds];
		});
	},
	watch: {
		sharedTo(){
			if(this.sharedTo.length === this.students.length){
				this.isAllClasseTriggered = true
			}
			else{
				this.isAllClasseTriggered = false
			}
		}
	}

}
</script>

<style>
.input-share-answer {
	margin-top: 20px;
	padding-top: 15px;
	border-top: 1px solid #e0e0e0;
}
</style>
